import { LoadBuildingSuggestions } from 'types/suggestions/LoadBuildingSuggestions';

// Values match the API's handledState field on load building suggestions.
export enum LoadBuildingHandledState {
  Active = 'active',
  Built = 'built',
}

// Why the backend marked a load building suggestion built.
export enum LoadBuildingHandledReason {
  // A rep built the load from this suggestion in Drumkit.
  DrumkitBuild = 'drumkit_build',
  // A load in the TMS already carries one of the suggestion's reference numbers.
  TmsMatch = 'tms_match',
}

// The load a built suggestion became, with the IDs the sidebar opens it by. Either ID can be
// empty. The backend sends the external TMS ID when the load has no freight tracking ID.
export type BuiltLoad = {
  loadID: number;
  freightTrackingID: string;
  externalTMSID: string;
};

export type PartitionedLoadBuildingSuggestions = {
  open: LoadBuildingSuggestions[];
  built: LoadBuildingSuggestions[];
};
